import { generatePresignedUrls } from '@services/presentations.service';

const uploadFileToS3 = async (file, filekey, onProgress, contentType = 'application/octet-stream') => {
  try {
    const payload = { pages: [{ s3Key: filekey, contentType }] };
    const response = await generatePresignedUrls(payload);
    if (!response?.status || !response?.entity?.[0]?.url) {
      throw new Error('Failed to get presigned URL');
    }

    const presignedUrl = response.entity[0].url;

    // Use XMLHttpRequest for progress tracking
    return await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable && onProgress) {
          const progress = Math.round((event.loaded / event.total) * 100);
          onProgress(progress);
        }
      });

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve({
            Location: presignedUrl.split('?')[0], // Remove query params to get the object URL
            Bucket: process.env.NEXT_PUBLIC_AWS_BUCKET,
            Key: filekey,
          });
        } else {
          reject(new Error(`Upload failed: ${xhr.status} ${xhr.statusText}`));
        }
      };

      xhr.onerror = () => {
        reject(new Error('Upload failed due to network error'));
      };

      xhr.open('PUT', presignedUrl);
      xhr.setRequestHeader('Content-Type', filekey.startsWith('Documents') ? file.type : 'application/octet-stream');
      xhr.send(file);
    });
  } catch (error) {
    console.error('Upload error', { error, filekey });
    throw error;
  }
};

export default uploadFileToS3;
